import app from "flarum/forum/app";
import RankPage from "./RankPage";
import SelectDropdown from "flarum/common/components/SelectDropdown";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import Placeholder from "flarum/common/components/Placeholder";
import Link from "flarum/common/components/Link";

export default class RankDataPage extends RankPage {
  type: string | null = null;
  loading = false;
  rank: any[] | null = null;
  playerRank: any | null = null;
  playerRankXHR: XMLHttpRequest | null = null;
  users: any[] | null = null;
  usersXHR: XMLHttpRequest | null = null;

  title() {
    return ""
  }

  ranksUrl() {
    return "";
  }

  rankUrl(steamid: string) {
    return "";
  }

  getTypes(): any[] {
    return [];
  }

  playerLink(steamid: string): string {
    return app.route("player.zs_data", {steamid});
  }

  oncreate(vnode: any) {
    super.oncreate(vnode);

    app.setTitle(this.title());
    app.setTitleCount(0);

    this.refresh();
  }

  content() {
    const types = this.getTypes();

    return <div><div>{SelectDropdown.component({buttonClassName: "Button"}, types)}</div>
      {this.loading ? <LoadingIndicator/> : (this.rank ?
        <table className="rank-list">
          <thead>
          <th>排名</th>
          <th>玩家名称</th>
          <th>数量</th>
          </thead>
          <tbody>
          {
            this.rank?.map((rank) => <tr className={"rank-list-player" + ((app.session.user && app.session.user.data.attributes?.steamID == rank.id) ? " rank-list-self" : "")}>
              <td>{rank.rank}</td>
              <td><Link href={this.playerLink(rank.id)}>{rank.name}</Link>{
                (this.users && this.users[rank.id]) ? <span>（<a href={this.users[rank.id].url}>论坛个人资料</a>）</span> : ""
              }</td>
              <td>{new Intl.NumberFormat("en-US").format(rank.amount)}</td>
            </tr>)
          }
          {
            this.playerRank ? <tr className="rank-list-player rank-list-self">
              <td>{this.playerRank.rank}</td>
              <td><Link href={this.playerLink(this.playerRank.id)}>{this.playerRank.name}</Link></td>
              <td>{new Intl.NumberFormat("en-US").format(this.playerRank.amount)}</td>
            </tr> : ""
          }
          </tbody>
        </table> : <Placeholder text={app.translator.trans("rhodes-island.forum.rank.not_available")}/>)}
    </div>;
  }

  changeType(type: any) {
    this.type = type;
    this.refresh();
  }

  refresh() {
    this.abortPlayerRankQuery();
    this.abortUsersQuery();
    this.loading = true;
    this.rank = this.playerRank = null;
    m.redraw();
    m.request({
      url: this.ranksUrl(),
    }).then((data: any) => {
      if (data.success) {
        this.rank = data.rank;
        let ids = [];
        for (let ply of this.rank || []) {
          ids.push(ply.id);
        }
        m.request({
          url: app.forum.attribute("baseUrl") + "/api/steam/findUsers?steamids=" + ids.join(","),
          config: (xhr: XMLHttpRequest) => this.usersXHR = xhr
        }).then((data: any) => {
          if (data.success) {
            this.users = data.users;
            m.redraw();
          }
        }).finally(() => this.usersXHR = null);
        if (app.session.user && app.session.user.data.attributes?.steamID) {
          for (let item of this.rank || []) {
            if (item.id == app.session.user.data.attributes.steamID) {
              // Current player is inside the rank, so we don't have to request again.
              return;
            }
          }
          m.request({
            url: this.rankUrl(app.session.user.data.attributes.steamID as string),
            config: (xhr: XMLHttpRequest) => this.playerRankXHR = xhr
          }).then((data: any) => {
            if (data.success) {
              this.playerRank = data.rank;
              m.redraw();
            }
          }).finally(() => {
            this.playerRankXHR = null;
          });
        }
      } else {
        setTimeout(() => this.refresh, 3000);
      }
    }).catch(() => setTimeout(() => this.refresh, 3000)).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }

  abortPlayerRankQuery() {
    if (this.playerRankXHR) this.playerRankXHR.abort();
    this.playerRankXHR = null;
  }

  abortUsersQuery() {
    if (this.usersXHR) this.usersXHR.abort();
    this.usersXHR = null;
  }
}
